import React from "react";
import Navigation from "./Navigation";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";

function App() {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <div className="d-flex">
          <BrowserRouter>
            <Navigation />
          </BrowserRouter>
        </div>
      </QueryClientProvider>
    </>
  );
}

export default App;
